const countries = [
  { name: 'Afghanistan', abbreviation: 'AF', 'country-code': '004' },
  { name: 'Åland Islands', abbreviation: 'AX', 'country-code': '248' },
  { name: 'Albania', abbreviation: 'AL', 'country-code': '008' },
  { name: 'Algeria', abbreviation: 'DZ', 'country-code': '012' },
  { name: 'American Samoa', abbreviation: 'AS', 'country-code': '016' },
  { name: 'Andorra', abbreviation: 'AD', 'country-code': '020' },
  { name: 'Angola', abbreviation: 'AO', 'country-code': '024' },
  { name: 'Anguilla', abbreviation: 'AI', 'country-code': '660' },
  { name: 'Antarctica', abbreviation: 'AQ', 'country-code': '010' },
  { name: 'Antigua and Barbuda', abbreviation: 'AG', 'country-code': '028' },
  { name: 'Argentina', abbreviation: 'AR', 'country-code': '032' },
  { name: 'Armenia', abbreviation: 'AM', 'country-code': '051' },
  { name: 'Aruba', abbreviation: 'AW', 'country-code': '533' },
  { name: 'Australia', abbreviation: 'AU', 'country-code': '036' },
  { name: 'Austria', abbreviation: 'AT', 'country-code': '040' },
  { name: 'Azerbaijan', abbreviation: 'AZ', 'country-code': '031' },
  { name: 'Bahamas', abbreviation: 'BS', 'country-code': '044' },
  { name: 'Bahrain', abbreviation: 'BH', 'country-code': '048' },
  { name: 'Bangladesh', abbreviation: 'BD', 'country-code': '050' },
  { name: 'Barbados', abbreviation: 'BB', 'country-code': '052' },
  { name: 'Belarus', abbreviation: 'BY', 'country-code': '112' },
  { name: 'Belgium', abbreviation: 'BE', 'country-code': '056' },
  { name: 'Belize', abbreviation: 'BZ', 'country-code': '084' },
  { name: 'Benin', abbreviation: 'BJ', 'country-code': '204' },
  { name: 'Bermuda', abbreviation: 'BM', 'country-code': '060' },
  { name: 'Bhutan', abbreviation: 'BT', 'country-code': '064' },
  { name: 'Bolivia (Plurinational State of)', abbreviation: 'BO', 'country-code': '068' },
  { name: 'Bonaire, Sint Eustatius and Saba', abbreviation: 'BQ', 'country-code': '535' },
  { name: 'Bosnia and Herzegovina', abbreviation: 'BA', 'country-code': '070' },
  { name: 'Botswana', abbreviation: 'BW', 'country-code': '072' },
  { name: 'Bouvet Island', abbreviation: 'BV', 'country-code': '074' },
  { name: 'Brazil', abbreviation: 'BR', 'country-code': '076' },
  { name: 'British Indian Ocean Territory', abbreviation: 'IO', 'country-code': '086' },
  { name: 'Brunei Darussalam', abbreviation: 'BN', 'country-code': '096' },
  { name: 'Bulgaria', abbreviation: 'BG', 'country-code': '100' },
  { name: 'Burkina Faso', abbreviation: 'BF', 'country-code': '854' },
  { name: 'Burundi', abbreviation: 'BI', 'country-code': '108' },
  { name: 'Cabo Verde', abbreviation: 'CV', 'country-code': '132' },
  { name: 'Cambodia', abbreviation: 'KH', 'country-code': '116' },
  { name: 'Cameroon', abbreviation: 'CM', 'country-code': '120' },
  { name: 'Canada', abbreviation: 'CA', 'country-code': '124' },
  { name: 'Cayman Islands', abbreviation: 'KY', 'country-code': '136' },
  { name: 'Central African Republic', abbreviation: 'CF', 'country-code': '140' },
  { name: 'Chad', abbreviation: 'TD', 'country-code': '148' },
  { name: 'Chile', abbreviation: 'CL', 'country-code': '152' },
  { name: 'China', abbreviation: 'CN', 'country-code': '156' },
  { name: 'Christmas Island', abbreviation: 'CX', 'country-code': '162' },
  { name: 'Cocos (Keeling) Islands', abbreviation: 'CC', 'country-code': '166' },
  { name: 'Colombia', abbreviation: 'CO', 'country-code': '170' },
  { name: 'Comoros', abbreviation: 'KM', 'country-code': '174' },
  { name: 'Congo', abbreviation: 'CG', 'country-code': '178' },
  { name: 'Congo, Democratic Republic of the', abbreviation: 'CD', 'country-code': '180' },
  { name: 'Cook Islands', abbreviation: 'CK', 'country-code': '184' },
  { name: 'Costa Rica', abbreviation: 'CR', 'country-code': '188' },
  { name: "Côte d'Ivoire", abbreviation: 'CI', 'country-code': '384' },
  { name: 'Croatia', abbreviation: 'HR', 'country-code': '191' },
  { name: 'Cuba', abbreviation: 'CU', 'country-code': '192' },
  { name: 'Curaçao', abbreviation: 'CW', 'country-code': '531' },
  { name: 'Cyprus', abbreviation: 'CY', 'country-code': '196' },
  { name: 'Czechia', abbreviation: 'CZ', 'country-code': '203' },
  { name: 'Denmark', abbreviation: 'DK', 'country-code': '208' },
  { name: 'Djibouti', abbreviation: 'DJ', 'country-code': '262' },
  { name: 'Dominica', abbreviation: 'DM', 'country-code': '212' },
  { name: 'Dominican Republic', abbreviation: 'DO', 'country-code': '214' },
  { name: 'Ecuador', abbreviation: 'EC', 'country-code': '218' },
  { name: 'Egypt', abbreviation: 'EG', 'country-code': '818' },
  { name: 'El Salvador', abbreviation: 'SV', 'country-code': '222' },
  { name: 'Equatorial Guinea', abbreviation: 'GQ', 'country-code': '226' },
  { name: 'Eritrea', abbreviation: 'ER', 'country-code': '232' },
  { name: 'Estonia', abbreviation: 'EE', 'country-code': '233' },
  { name: 'Eswatini', abbreviation: 'SZ', 'country-code': '748' },
  { name: 'Ethiopia', abbreviation: 'ET', 'country-code': '231' },
  { name: 'Falkland Islands (Malvinas)', abbreviation: 'FK', 'country-code': '238' },
  { name: 'Faroe Islands', abbreviation: 'FO', 'country-code': '234' },
  { name: 'Fiji', abbreviation: 'FJ', 'country-code': '242' },
  { name: 'Finland', abbreviation: 'FI', 'country-code': '246' },
  { name: 'France', abbreviation: 'FR', 'country-code': '250' },
  { name: 'French Guiana', abbreviation: 'GF', 'country-code': '254' },
  { name: 'French Polynesia', abbreviation: 'PF', 'country-code': '258' },
  { name: 'French Southern Territories', abbreviation: 'TF', 'country-code': '260' },
  { name: 'Gabon', abbreviation: 'GA', 'country-code': '266' },
  { name: 'Gambia', abbreviation: 'GM', 'country-code': '270' },
  { name: 'Georgia', abbreviation: 'GE', 'country-code': '268' },
  { name: 'Germany', abbreviation: 'DE', 'country-code': '276' },
  { name: 'Ghana', abbreviation: 'GH', 'country-code': '288' },
  { name: 'Gibraltar', abbreviation: 'GI', 'country-code': '292' },
  { name: 'Greece', abbreviation: 'GR', 'country-code': '300' },
  { name: 'Greenland', abbreviation: 'GL', 'country-code': '304' },
  { name: 'Grenada', abbreviation: 'GD', 'country-code': '308' },
  { name: 'Guadeloupe', abbreviation: 'GP', 'country-code': '312' },
  { name: 'Guam', abbreviation: 'GU', 'country-code': '316' },
  { name: 'Guatemala', abbreviation: 'GT', 'country-code': '320' },
  { name: 'Guernsey', abbreviation: 'GG', 'country-code': '831' },
  { name: 'Guinea', abbreviation: 'GN', 'country-code': '324' },
  { name: 'Guinea-Bissau', abbreviation: 'GW', 'country-code': '624' },
  { name: 'Guyana', abbreviation: 'GY', 'country-code': '328' },
  { name: 'Haiti', abbreviation: 'HT', 'country-code': '332' },
  { name: 'Heard Island and McDonald Islands', abbreviation: 'HM', 'country-code': '334' },
  { name: 'Holy See', abbreviation: 'VA', 'country-code': '336' },
  { name: 'Honduras', abbreviation: 'HN', 'country-code': '340' },
  { name: 'Hong Kong', abbreviation: 'HK', 'country-code': '344' },
  { name: 'Hungary', abbreviation: 'HU', 'country-code': '348' },
  { name: 'Iceland', abbreviation: 'IS', 'country-code': '352' },
  { name: 'India', abbreviation: 'IN', 'country-code': '356' },
  { name: 'Indonesia', abbreviation: 'ID', 'country-code': '360' },
  { name: 'Iran (Islamic Republic of)', abbreviation: 'IR', 'country-code': '364' },
  { name: 'Iraq', abbreviation: 'IQ', 'country-code': '368' },
  { name: 'Ireland', abbreviation: 'IE', 'country-code': '372' },
  { name: 'Isle of Man', abbreviation: 'IM', 'country-code': '833' },
  { name: 'Israel', abbreviation: 'IL', 'country-code': '376' },
  { name: 'Italy', abbreviation: 'IT', 'country-code': '380' },
  { name: 'Jamaica', abbreviation: 'JM', 'country-code': '388' },
  { name: 'Japan', abbreviation: 'JP', 'country-code': '392' },
  { name: 'Jersey', abbreviation: 'JE', 'country-code': '832' },
  { name: 'Jordan', abbreviation: 'JO', 'country-code': '400' },
  { name: 'Kazakhstan', abbreviation: 'KZ', 'country-code': '398' },
  { name: 'Kenya', abbreviation: 'KE', 'country-code': '404' },
  { name: 'Kiribati', abbreviation: 'KI', 'country-code': '296' },
  { name: "Korea (Democratic People's Republic of)", abbreviation: 'KP', 'country-code': '408' },
  { name: 'Korea, Republic of', abbreviation: 'KR', 'country-code': '410' },
  { name: 'Kuwait', abbreviation: 'KW', 'country-code': '414' },
  { name: 'Kyrgyzstan', abbreviation: 'KG', 'country-code': '417' },
  { name: "Lao People's Democratic Republic", abbreviation: 'LA', 'country-code': '418' },
  { name: 'Latvia', abbreviation: 'LV', 'country-code': '428' },
  { name: 'Lebanon', abbreviation: 'LB', 'country-code': '422' },
  { name: 'Lesotho', abbreviation: 'LS', 'country-code': '426' },
  { name: 'Liberia', abbreviation: 'LR', 'country-code': '430' },
  { name: 'Libya', abbreviation: 'LY', 'country-code': '434' },
  { name: 'Liechtenstein', abbreviation: 'LI', 'country-code': '438' },
  { name: 'Lithuania', abbreviation: 'LT', 'country-code': '440' },
  { name: 'Luxembourg', abbreviation: 'LU', 'country-code': '442' },
  { name: 'Macao', abbreviation: 'MO', 'country-code': '446' },
  { name: 'Madagascar', abbreviation: 'MG', 'country-code': '450' },
  { name: 'Malawi', abbreviation: 'MW', 'country-code': '454' },
  { name: 'Malaysia', abbreviation: 'MY', 'country-code': '458' },
  { name: 'Maldives', abbreviation: 'MV', 'country-code': '462' },
  { name: 'Mali', abbreviation: 'ML', 'country-code': '466' },
  { name: 'Malta', abbreviation: 'MT', 'country-code': '470' },
  { name: 'Marshall Islands', abbreviation: 'MH', 'country-code': '584' },
  { name: 'Martinique', abbreviation: 'MQ', 'country-code': '474' },
  { name: 'Mauritania', abbreviation: 'MR', 'country-code': '478' },
  { name: 'Mauritius', abbreviation: 'MU', 'country-code': '480' },
  { name: 'Mayotte', abbreviation: 'YT', 'country-code': '175' },
  { name: 'Mexico', abbreviation: 'MX', 'country-code': '484' },
  { name: 'Micronesia (Federated States of)', abbreviation: 'FM', 'country-code': '583' },
  { name: 'Moldova, Republic of', abbreviation: 'MD', 'country-code': '498' },
  { name: 'Monaco', abbreviation: 'MC', 'country-code': '492' },
  { name: 'Mongolia', abbreviation: 'MN', 'country-code': '496' },
  { name: 'Montenegro', abbreviation: 'ME', 'country-code': '499' },
  { name: 'Montserrat', abbreviation: 'MS', 'country-code': '500' },
  { name: 'Morocco', abbreviation: 'MA', 'country-code': '504' },
  { name: 'Mozambique', abbreviation: 'MZ', 'country-code': '508' },
  { name: 'Myanmar', abbreviation: 'MM', 'country-code': '104' },
  { name: 'Namibia', abbreviation: 'NA', 'country-code': '516' },
  { name: 'Nauru', abbreviation: 'NR', 'country-code': '520' },
  { name: 'Nepal', abbreviation: 'NP', 'country-code': '524' },
  { name: 'Netherlands', abbreviation: 'NL', 'country-code': '528' },
  { name: 'New Caledonia', abbreviation: 'NC', 'country-code': '540' },
  { name: 'New Zealand', abbreviation: 'NZ', 'country-code': '554' },
  { name: 'Nicaragua', abbreviation: 'NI', 'country-code': '558' },
  { name: 'Niger', abbreviation: 'NE', 'country-code': '562' },
  { name: 'Nigeria', abbreviation: 'NG', 'country-code': '566' },
  { name: 'Niue', abbreviation: 'NU', 'country-code': '570' },
  { name: 'Norfolk Island', abbreviation: 'NF', 'country-code': '574' },
  { name: 'North Macedonia', abbreviation: 'MK', 'country-code': '807' },
  { name: 'Northern Mariana Islands', abbreviation: 'MP', 'country-code': '580' },
  { name: 'Norway', abbreviation: 'NO', 'country-code': '578' },
  { name: 'Oman', abbreviation: 'OM', 'country-code': '512' },
  { name: 'Pakistan', abbreviation: 'PK', 'country-code': '586' },
  { name: 'Palau', abbreviation: 'PW', 'country-code': '585' },
  { name: 'Palestine, State of', abbreviation: 'PS', 'country-code': '275' },
  { name: 'Panama', abbreviation: 'PA', 'country-code': '591' },
  { name: 'Papua New Guinea', abbreviation: 'PG', 'country-code': '598' },
  { name: 'Paraguay', abbreviation: 'PY', 'country-code': '600' },
  { name: 'Peru', abbreviation: 'PE', 'country-code': '604' },
  { name: 'Philippines', abbreviation: 'PH', 'country-code': '608' },
  { name: 'Pitcairn', abbreviation: 'PN', 'country-code': '612' },
  { name: 'Poland', abbreviation: 'PL', 'country-code': '616' },
  { name: 'Portugal', abbreviation: 'PT', 'country-code': '620' },
  { name: 'Puerto Rico', abbreviation: 'PR', 'country-code': '630' },
  { name: 'Qatar', abbreviation: 'QA', 'country-code': '634' },
  { name: 'Réunion', abbreviation: 'RE', 'country-code': '638' },
  { name: 'Romania', abbreviation: 'RO', 'country-code': '642' },
  { name: 'Russian Federation', abbreviation: 'RU', 'country-code': '643' },
  { name: 'Rwanda', abbreviation: 'RW', 'country-code': '646' },
  { name: 'Saint Barthélemy', abbreviation: 'BL', 'country-code': '652' },
  { name: 'Saint Helena, Ascension and Tristan da Cunha', abbreviation: 'SH', 'country-code': '654' },
  { name: 'Saint Kitts and Nevis', abbreviation: 'KN', 'country-code': '659' },
  { name: 'Saint Lucia', abbreviation: 'LC', 'country-code': '662' },
  { name: 'Saint Martin (French part)', abbreviation: 'MF', 'country-code': '663' },
  { name: 'Saint Pierre and Miquelon', abbreviation: 'PM', 'country-code': '666' },
  { name: 'Saint Vincent and the Grenadines', abbreviation: 'VC', 'country-code': '670' },
  { name: 'Samoa', abbreviation: 'WS', 'country-code': '882' },
  { name: 'San Marino', abbreviation: 'SM', 'country-code': '674' },
  { name: 'Sao Tome and Principe', abbreviation: 'ST', 'country-code': '678' },
  { name: 'Saudi Arabia', abbreviation: 'SA', 'country-code': '682' },
  { name: 'Senegal', abbreviation: 'SN', 'country-code': '686' },
  { name: 'Serbia', abbreviation: 'RS', 'country-code': '688' },
  { name: 'Seychelles', abbreviation: 'SC', 'country-code': '690' },
  { name: 'Sierra Leone', abbreviation: 'SL', 'country-code': '694' },
  { name: 'Singapore', abbreviation: 'SG', 'country-code': '702' },
  { name: 'Sint Maarten (Dutch part)', abbreviation: 'SX', 'country-code': '534' },
  { name: 'Slovakia', abbreviation: 'SK', 'country-code': '703' },
  { name: 'Slovenia', abbreviation: 'SI', 'country-code': '705' },
  { name: 'Solomon Islands', abbreviation: 'SB', 'country-code': '090' },
  { name: 'Somalia', abbreviation: 'SO', 'country-code': '706' },
  { name: 'South Africa', abbreviation: 'ZA', 'country-code': '710' },
  { name: 'South Georgia and the South Sandwich Islands', abbreviation: 'GS', 'country-code': '239' },
  { name: 'South Sudan', abbreviation: 'SS', 'country-code': '728' },
  { name: 'Spain', abbreviation: 'ES', 'country-code': '724' },
  { name: 'Sri Lanka', abbreviation: 'LK', 'country-code': '144' },
  { name: 'Sudan', abbreviation: 'SD', 'country-code': '729' },
  { name: 'Suriname', abbreviation: 'SR', 'country-code': '740' },
  { name: 'Svalbard and Jan Mayen', abbreviation: 'SJ', 'country-code': '744' },
  { name: 'Sweden', abbreviation: 'SE', 'country-code': '752' },
  { name: 'Switzerland', abbreviation: 'CH', 'country-code': '756' },
  { name: 'Syrian Arab Republic', abbreviation: 'SY', 'country-code': '760' },
  { name: 'Taiwan, Province of China', abbreviation: 'TW', 'country-code': '158' },
  { name: 'Tajikistan', abbreviation: 'TJ', 'country-code': '762' },
  { name: 'Tanzania, United Republic of', abbreviation: 'TZ', 'country-code': '834' },
  { name: 'Thailand', abbreviation: 'TH', 'country-code': '764' },
  { name: 'Timor-Leste', abbreviation: 'TL', 'country-code': '626' },
  { name: 'Togo', abbreviation: 'TG', 'country-code': '768' },
  { name: 'Tokelau', abbreviation: 'TK', 'country-code': '772' },
  { name: 'Tonga', abbreviation: 'TO', 'country-code': '776' },
  { name: 'Trinidad and Tobago', abbreviation: 'TT', 'country-code': '780' },
  { name: 'Tunisia', abbreviation: 'TN', 'country-code': '788' },
  { name: 'Turkey', abbreviation: 'TR', 'country-code': '792' },
  { name: 'Turkmenistan', abbreviation: 'TM', 'country-code': '795' },
  { name: 'Turks and Caicos Islands', abbreviation: 'TC', 'country-code': '796' },
  { name: 'Tuvalu', abbreviation: 'TV', 'country-code': '798' },
  { name: 'Uganda', abbreviation: 'UG', 'country-code': '800' },
  { name: 'Ukraine', abbreviation: 'UA', 'country-code': '804' },
  { name: 'United Arab Emirates', abbreviation: 'AE', 'country-code': '784' },
  { name: 'United Kingdom of Great Britain and Northern Ireland', abbreviation: 'GB', 'country-code': '826' },
  { name: 'United States of America', abbreviation: 'US', 'country-code': '840' },
  { name: 'United States Minor Outlying Islands', abbreviation: 'UM', 'country-code': '581' },
  { name: 'Uruguay', abbreviation: 'UY', 'country-code': '858' },
  { name: 'Uzbekistan', abbreviation: 'UZ', 'country-code': '860' },
  { name: 'Vanuatu', abbreviation: 'VU', 'country-code': '548' },
  { name: 'Venezuela (Bolivarian Republic of)', abbreviation: 'VE', 'country-code': '862' },
  { name: 'Viet Nam', abbreviation: 'VN', 'country-code': '704' },
  { name: 'Virgin Islands (British)', abbreviation: 'VG', 'country-code': '092' },
  { name: 'Virgin Islands (U.S.)', abbreviation: 'VI', 'country-code': '850' },
  { name: 'Wallis and Futuna', abbreviation: 'WF', 'country-code': '876' },
  { name: 'Western Sahara', abbreviation: 'EH', 'country-code': '732' },
  { name: 'Yemen', abbreviation: 'YE', 'country-code': '887' },
  { name: 'Zambia', abbreviation: 'ZM', 'country-code': '894' },
  { name: 'Zimbabwe', abbreviation: 'ZW', 'country-code': '716' }
]

export default countries
